export const bindMethod = (add?: boolean) => add ? 'addEventListener' : 'removeEventListener'
export const bindEmitterMethod = (add: boolean) => add ? 'on' : 'off'
